import { child, get, getDatabase, ref } from "firebase/database";
import { React, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "../index.css";
import ErrorMessage from "./ErrorMessage";

function UserInfo(props) {
  // user info should be passed to this thing
  // username, userimage, spacename

    let altString = "" + props.username + "'s profile";

    return(
        <div>
            <img className="d-block p-2 prof-image"
            src={props.userimage}
            alt={altString} />
        </div>
    )
}

function UserDescription(props) {
  // bannerImage, description

    return(
        <div className="p-2">
            <h1>{props.username}</h1>
            <p>{props.description}</p>
        </div>
    )
}
function Gallery(props) {
  return (
    <div className="d-flex col">
      <div className="gallery">
        {" "}
        <img
          src={props.space.image}
          alt={props.space.title}
          className="w-100"
        />
      </div>
    </div>
  );
}

function SpaceDescription(props) {
  return (
    <div className="card">
      <div className="card-body">
        <div className="bg-light p-5">
          <h2>{props.username}'s space</h2>
          <div className="prof-space-info">
            <Gallery space={props.space} />
            <div className="prof-space-desc p-4">
              <h3>
                {props.space.title} ${props.space.price}
              </h3>
              <p>{props.space.description}</p>
              <div className="descbtn">
                <Link to={"/rent/" + useParams().uid}>
                  <div className="btn">RENT NOW</div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Profile(props) {
  // setup state
  const [isLoaded, setIsLoaded] = useState();
  const [user, setUser] = useState();
  const [errorMessage, setErrorMessage] = useState("");

  let userId = useParams().uid;
  if (!userId) {
    return <ErrorMessage errorMessage={"Error loading user."} />;
  }

  if (isLoaded) {
    if (!user) {
      return <ErrorMessage errorMessage={"Error loading user."} />;
    }

    let bannerImage =
      (user.bannerImg && user.bannerImg.length === 0) || !user.bannerImg
        ? "../img/defaultBanner.jpg"
        : user.bannerImg; // fallback for banner image if empty or undefined
    let userImage =
      (user.pfp_link && user.pfp_link.length === 0) || !user.pfp_link
        ? "../img/defaultProfile.jpg"
        : user.pfp_link; // fallback for banner image if empty or undefined

    return (
      <main className="container">
        <ErrorMessage errorMessage={errorMessage} />
        <div className="d-flex flex-column align-items-center">
          <div className="w-100 d-flex flex-col p-3">
            <UserInfo userimage={userImage} spacename={user.space.title} />
            <UserDescription
              bannerImage={bannerImage}
              username={user["first_name"] + " " + user["last_name"]}
              description={user["about_me"]}
            />
          </div>
          <SpaceDescription
            username={user["first_name"] + " " + user["last_name"]}
            space={user.space}
          />
        </div>
      </main>
    );
  } else {
    // i.e., if (isLoaded not true)
    // get users data
    get(child(ref(getDatabase()), "/users"))
      .then((snapshot) => {
        return snapshot.val();
      })
      .then((Users) => {
        const user = Users[userId];
        setUser(user);
        setIsLoaded(true);
      })
      .catch((err) => {
        setErrorMessage(err.message);
      });

    return (
      <p>Loading...</p>
    );
  }
}
